import './S_FieldError.scss';
import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
interface S_FieldErrorProps {
  feedbacks: TranslationKey[];
  feedbacksParams?: Record<string, string | number | null>;
}

export const S_FieldError = observer((props: S_FieldErrorProps): ReactElement => {
  const { t } = useTranslator();

  const renderFeedback = (feedback: TranslationKey, index: number): ReactNode => {
    return (
      <li
        className='form-feedback-item'
        key={index}
      >
        {t(feedback, props.feedbacksParams || {})}
      </li>
    );
  };

  return (
    <div className='form-feedback'>
      <ul className='form-feedback-list'>{props.feedbacks.map(renderFeedback)}</ul>
    </div>
  );
});
